import React from "react";
import { useSelector } from "react-redux";
import { AccessibilityHiddenImg, AccessibilityHidden } from '@skillz/accessibility';
import Tooltip from "../../components/ui/tooltip/Tooltip";
import useTextByLangAndGender from "../../hooks/useTextByLangAndGender";
import classes from "./Footer.module.css"

const Footer = () => {

    const generalData = useSelector((state) => state.uiData.general?.footer);
    const { texts } = useSelector(state => state.translate);
    const { isAuth } = useSelector(state => state.auth);
    const textByLangAndGender = useTextByLangAndGender()

    return (
        <>
            {generalData && <div className={`${classes.FooterWrapper} ${isAuth === false ? classes.FooterWrapperNotAuth : ''}`}>
                {isAuth === false && generalData.iconsLinks && <div className={classes.Icons}>
                    {generalData.iconsLinks.map(iconLink => {
                        return iconLink.link && <Tooltip key={iconLink.link} text={textByLangAndGender(iconLink.text)} showTooltip={true}>
                            <a aria-label={textByLangAndGender(iconLink.text)} href={iconLink.link} target="_blank" rel="noreferrer">
                                <AccessibilityHiddenImg src={iconLink.icon} />
                            </a>
                        </Tooltip>
                    })}
                </div>}

                <div className={classes.Links}>
                    <>
                        <p>{texts.allRightsReserved}</p>
                        <p className={classes.WebLine}>|</p>
                    </>

                    <div className={classes.GroupMobile}>
                        <a href={generalData.freedomOfInformationActLink} target="_blank" rel="noreferrer">{texts.freedomOfInformationActLink}</a>
                    </div>
                    <div className={classes.GroupMobile}>
                        <>
                            <AccessibilityHidden><p className={classes.WebLine}>|</p></AccessibilityHidden>
                            <a href={generalData.termsUseLink} target="_blank" rel="noreferrer">{texts.termsUseLink}</a>
                        </>
                        <>
                            <AccessibilityHidden><p>|</p></AccessibilityHidden>
                            <a href={generalData.termsOfUseLink} target="_blank" rel="noreferrer">{texts.termsOfUseLink}</a>
                        </>
                        <>
                            <AccessibilityHidden><p>|</p></AccessibilityHidden>
                            <a href={generalData.accessibilityStatementLink} target="_blank" rel="noreferrer">{texts.accessibilityStatementLink}</a>
                        </>

                    </div>
                </div>
            </div >}
        </>
    )
}

export default Footer;